module.exports = __webpack_public_path__ + "img/banner_yn.1f5a672d.png";